import './HeaderStyle.css';
import { ErnotsConfig } from "../../ErnotsConfig";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { LogoutLink } from "../login/LogoutLink";
import { LoginLink } from "../login/LoginLink";
import { NavLink } from "react-router-dom";
import { RequestStatusDisplay } from "../CommonComponents";
import { useEffect, useState } from "react";
import { initializeCsrf, RequestStatus } from "../../api_request/api_request";

export function Header()
{
    const appDispatch = useAppDispatch();

    const [csrfRequest, setCsrfRequest] = useState<RequestStatus|undefined>(undefined);
    useEffect(() => {initializeCsrf(appDispatch, setCsrfRequest)}, [appDispatch]);

    const loggedInUserName = useAppSelector((state) => state.login.currentUser.username);
    const backendUnreachable = useAppSelector((state) => state.apiRequests.backendUnreachable);

    const leftSide = loggedInUserName
        ? <>
            <NavLink className='ernots_NavLink' to={'books'}>Books</NavLink>&nbsp;
            <NavLink className='ernots_NavLink' to={'languages'}>Languages</NavLink>&nbsp;
            <NavLink className='ernots_NavLink' to={'abbreviations'}>Abbreviations</NavLink>&nbsp;
            <NavLink className='ernots_NavLink' to={'dictlinks'}>Dictionaries</NavLink>&nbsp;
            <NavLink className='ernots_NavLink' to={'arbitrarytext'}>Translate Arbitrary Text</NavLink>&nbsp;
        </>
        : <></>;

    const rightSide = <RequestStatusDisplay
        request={csrfRequest}
        processing_message={<>Connecting...</>}
        success_message={loggedInUserName ? <LogoutLink/> : <LoginLink/>}
        error_message={<></>}/>

    const backendUnreachableMsg = backendUnreachable
        ? <span className='ernots_BackendUnreachableMsg'>&nbsp;Backend server unreachable</span>
        : <></>;

    return (
    <header className='ernots_SiteHeader'>
        <div className='ernots_SiteName'>
            {ErnotsConfig.AppNameLong}
        </div>
        <div className='ernots_SiteSubtitle'>
            A tool to help you practice any language by reading it in parallel with your native one.
        </div>

        <nav className='ernots_NavWrapper'>
            <NavLink to={''}>Home</NavLink>&nbsp;
            {leftSide}
            <span className='ernots_NavWrapperExpander'></span>
            {rightSide}
            {backendUnreachableMsg}
        </nav>
    </header>
    );
}